/* Font palette options. id maps to CSS font-family stack applied via inline style on the root. */

export const FONTS = [
  {
    id: "big-shoulders",
    name: "Big Shoulders",
    note: "Matches the logo. Bold, geometric, condensed.",
    family: "'Big Shoulders Display', system-ui, sans-serif",
  },
  {
    id: "playfair",
    name: "Playfair",
    note: "Editorial serif. Classic, magazine.",
    family: "'Playfair Display', 'EB Garamond', Georgia, serif",
  },
  {
    id: "cormorant",
    name: "Cormorant",
    note: "Luxury serif. Quiet, fine-art.",
    family: "'Cormorant Garamond', 'Playfair Display', Georgia, serif",
  },
  {
    id: "space-grotesk",
    name: "Space Grotesk",
    note: "Modern geometric sans. Tech-minimal.",
    family: "'Space Grotesk', system-ui, sans-serif",
  },
  {
    id: "manrope",
    name: "Manrope",
    note: "Clean, soft sans. Wellness-app feel.",
    family: "'Manrope', system-ui, sans-serif",
  },
  {
    id: "eb-garamond",
    name: "EB Garamond",
    note: "Warm classical serif. Editorial print.",
    family: "'EB Garamond', 'Cormorant Garamond', Georgia, serif",
  },
];
